/* BOOSTER MOON – main JS */
'use strict';

// ── Nav scroll ──
(function () {
  const nav = document.getElementById('nav');
  if (!nav) return;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 20);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── Mobile menu ──
(function () {
  const btn = document.getElementById('hamburger');
  const menu = document.getElementById('mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    menu.style.display = open ? 'flex' : 'none';
    btn.setAttribute('aria-expanded', open);
  });
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    menu.classList.remove('open');
    menu.style.display = 'none';
  }));
})();

// ── FAQ accordion ──
(function () {
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const a = q.nextElementSibling;
      if (!a) return;
      const wasOpen = q.classList.contains('open');
      document.querySelectorAll('.faq-q.open').forEach(oq => {
        oq.classList.remove('open');
        const oa = oq.nextElementSibling;
        if (oa) oa.classList.remove('open');
      });
      if (!wasOpen) {
        q.classList.add('open');
        a.classList.add('open');
      }
    });
  });
})();

// ── Reveal on scroll ──
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
    return;
  }
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
})();

// ── AJAX Cart ──
const Cart = (function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const bodyEl = document.getElementById('cart-body');
  const subtotalEl = document.getElementById('cart-subtotal');
  const savingsRow = document.getElementById('cart-savings-row');
  const savingsEl = document.getElementById('cart-savings');
  const countBadge = document.querySelector('.cart-count');

  function open() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  async function refreshDrawer() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderDrawer(cart);
  }

  function renderDrawer(cart) {
    if (!bodyEl) return;
    updateBadge(cart.item_count);

    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<p class="drawer-empty">Tu carrito está vacío.</p>';
      if (subtotalEl) subtotalEl.textContent = '0,00 €';
      if (savingsRow) savingsRow.style.display = 'none';
      return;
    }

    let itemsHTML = '';
    let totalSavings = 0;
    cart.items.forEach(item => {
      const comparePrice = item.compare_at_price || 0;
      const saving = (comparePrice - item.price) * item.quantity;
      if (saving > 0) totalSavings += saving;
      itemsHTML += `
      <div class="cart-item">
        <img class="cart-item-img" src="${item.image}" alt="${item.product_title}">
        <div>
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-qty">
            <button class="qty-btn-sm" data-action="dec" data-key="${item.key}" data-qty="${item.quantity}">&#8722;</button>
            <span class="cart-qty-num">${item.quantity}</span>
            <button class="qty-btn-sm" data-action="inc" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
        <div class="cart-item-price">${money(item.final_line_price)}</div>
      </div>`;
    });

    bodyEl.innerHTML = itemsHTML + giftsHTML(cart);

    bodyEl.querySelectorAll('.qty-btn-sm').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        const newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
        const res2 = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        renderDrawer(await res2.json());
      });
    });

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (savingsRow) {
      if (totalSavings > 0) {
        savingsRow.style.display = 'flex';
        if (savingsEl) savingsEl.textContent = money(totalSavings);
      } else {
        savingsRow.style.display = 'none';
      }
    }
  }

  // Regalos según el PACK (variante) presente en el carrito, no por nº de líneas.
  // El mapeo variante→tier lo inyecta la sección bm-bundles (window.BM_BUNDLES.tiers).
  function cartTier(cart) {
    const map = (window.BM_BUNDLES && window.BM_BUNDLES.tiers) || {};
    let tier = 0;
    cart.items.forEach(item => {
      const t = map[item.variant_id] || map[item.id] || 0;
      if (t > tier) tier = t;
    });
    // Fallback: si no hay mapeo configurado pero hay producto, garantiza tier 1.
    if (tier === 0 && cart.item_count > 0) tier = 1;
    return tier;
  }

  function giftsHTML(cart) {
    const tier = cartTier(cart);
    if (tier === 0) return '';
    let lines = '';
    if (tier >= 3) {
      lines = `<div class="gift-line"><span>&#10003;</span> Guía Hormonas — <strong>97€ GRATIS</strong></div>
               <div class="gift-line"><span>&#10003;</span> Shaker exclusivo — <strong>39€ GRATIS</strong></div>
               <div class="gift-line"><span>&#10003;</span> Envío prioritario <strong>GRATIS</strong></div>`;
    } else if (tier === 2) {
      lines = `<div class="gift-line"><span>&#10003;</span> Guía Hormonas — <strong>97€ GRATIS</strong></div>
               <div class="gift-line"><span>&#10003;</span> Envío prioritario <strong>GRATIS</strong></div>`;
    } else {
      lines = `<div class="gift-line"><span>&#10003;</span> Envío gratis en España</div>`;
    }
    return `<div class="drawer-gifts"><div class="drawer-gifts-title">REGALOS INCLUIDOS</div>${lines}</div>`;
  }

  function updateBadge(count) {
    if (!countBadge) return;
    countBadge.textContent = count;
    countBadge.style.display = count > 0 ? 'flex' : 'none';
  }

  if (overlay) overlay.addEventListener('click', close);
  const closeBtn = document.getElementById('cart-close');
  if (closeBtn) closeBtn.addEventListener('click', close);
  const navCartBtn = document.getElementById('nav-cart');
  if (navCartBtn) navCartBtn.addEventListener('click', open);

  return { open, close, refreshDrawer };
})();

// ── Add to cart buttons ──
document.querySelectorAll('.btn-add-cart').forEach(btn => {
  btn.addEventListener('click', async () => {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });
      if (!res.ok) throw new Error('error');
      btn.textContent = '✓ Añadido';
      Cart.open();
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2500);
    } catch (e) {
      btn.textContent = 'Error — Reintentar';
      btn.disabled = false;
    }
  });
});

// ── Top bar → bundles ──
(function () {
  const bar = document.getElementById('top-bar');
  if (bar) bar.addEventListener('click', () => {
    const sec = document.getElementById('bundles');
    if (sec) sec.scrollIntoView({ behavior: 'smooth' });
  });
})();

// ── Checkout ──
(function () {
  const btn = document.getElementById('btn-checkout');
  if (btn) btn.addEventListener('click', () => { window.location.href = '/checkout'; });
})();

// ── Moon phases on scroll (drives --phase: 0 full → 1 new) ──
(function () {
  const root = document.documentElement;
  const cosmos = document.getElementById('cosmos');
  if (!cosmos) return;
  let ticking = false;
  function update() {
    const vh = window.innerHeight || 1;
    const span = vh * 1.15;                       // full → new across ~1.15 viewports
    const p = Math.min(1, Math.max(0, window.scrollY / span));
    root.style.setProperty('--phase', p.toFixed(4));
    ticking = false;
  }
  window.addEventListener('scroll', () => {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

// ── Founder-access countdown (persisted rolling window) ──
(function () {
  const el = document.getElementById('tb-timer');
  if (!el) return;
  const KEY = 'bm_founder_deadline';
  const WINDOW = 3 * 24 * 60 * 60 * 1000;         // 72h window per visitor
  let deadline = parseInt(localStorage.getItem(KEY), 10);
  if (!deadline || isNaN(deadline) || deadline < Date.now()) {
    deadline = Date.now() + WINDOW;
    localStorage.setItem(KEY, String(deadline));
  }
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    let diff = deadline - Date.now();
    if (diff <= 0) { el.textContent = 'Última oportunidad'; return; }
    const d = Math.floor(diff / 86400000); diff -= d * 86400000;
    const h = Math.floor(diff / 3600000);  diff -= h * 3600000;
    const m = Math.floor(diff / 60000);    diff -= m * 60000;
    const s = Math.floor(diff / 1000);
    el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

// ── Phases timeline: illuminate sequentially when in view ──
(function () {
  const section = document.getElementById('phases');
  if (!section) return;
  const cards = section.querySelectorAll('.phase-card');
  if (!cards.length) return;
  if (!('IntersectionObserver' in window)) {
    cards.forEach(c => c.classList.add('lit'));
    return;
  }
  const obs = new IntersectionObserver((entries, o) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      cards.forEach((c, i) => setTimeout(() => c.classList.add('lit'), i * 220));
      o.disconnect();
    });
  }, { threshold: 0.25 });
  obs.observe(section);
})();
